import React from "react";
import HowWeWorkSection from "../modules/HowWeWorkSection/HowWeWorkSection.jsx";

const Rentals = () => {
	return (
		<HowWeWorkSection />
	);
};

export default Rentals;